/** Popover/menus for adding tags and choosing a parent task. */
import { Box, Menu, MenuItem, Popover } from '@mui/material';
import TaskParentSelector from '@/features/tasks/components/forms/fields/TaskParentSelector';

export function TaskFormTagMenus({
  addMenuAnchor,
  onCloseAddMenu,
  addMenuItems,
  onAddMenuSelect,
  editorAnchor,
  onCloseEditor,
  editorKind,
  task,
  parentTaskOptions,
  tasksMap,
  onParentChange,
}) {
  return (
    <>
      <Menu
        anchorEl={addMenuAnchor}
        open={Boolean(addMenuAnchor)}
        onClose={onCloseAddMenu}
      >
        {addMenuItems.map(({ kind, label }) => (
          <MenuItem key={kind} onClick={() => onAddMenuSelect(kind)}>
            {label}
          </MenuItem>
        ))}
      </Menu>

      <Popover
        open={Boolean(editorAnchor)}
        anchorEl={editorAnchor}
        onClose={onCloseEditor}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {editorKind === 'parent' ? (
          <Box sx={{ p: 2, width: 320, maxWidth: '90vw' }}>
            <TaskParentSelector
              task={task}
              parentTaskOptions={parentTaskOptions}
              tasksMap={tasksMap}
              onParentChange={(event, value) => {
                onParentChange(event, value);
                onCloseEditor();
              }}
            />
          </Box>
        ) : null}
      </Popover>
    </>
  );
}
